import {Component, Input, OnInit} from '@angular/core';
import {InscriptionsDTO} from "../../DTO/InscriptionsDTO";
import {TranslateService} from "@ngx-translate/core";
import {CommunityService} from "../../services/community/community.service";
import {ActivatedRoute} from "@angular/router";
import { InscriptionMinDTO } from 'src/app/DTO/min/InscriptionMinDTO';
@Component({
  selector: 'app-inscription-card',
  templateUrl: './inscription-card.component.html',
  styleUrl: './inscription-card.component.scss'
})
export class InscriptionCardComponent implements  OnInit{

  @Input() inscription: InscriptionMinDTO;

  public communityCode: string = '';
  public dateFrom: Date;
  public dateTo: Date = null;
  public defaultImg: string;
  public basePriceDisplayMode: 'hidden' | 'free' | 'amount' | 'from' = 'hidden';

  constructor(
    private translate: TranslateService,
    private communityService: CommunityService,
    private actRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.dateFrom = new Date(this.inscription.dateOpen);
    this.dateTo = new Date(this.inscription.dateClose);
    this.defaultImg = this.communityService.defaultImg;
    this.communityCode = this.actRoute.snapshot.params['community'];
    this.basePriceDisplayMode = this.resolveBasePriceDisplayMode(
      this.inscription.basePrice,
      this.inscription.priceVisibility
    );
  }

  private resolveBasePriceDisplayMode(
    basePrice: number | null | undefined,
    priceVisibility: 'Show' | 'ShowFrom' | 'Hide' | undefined
  ): 'hidden' | 'free' | 'amount' | 'from' {
    const paid = (basePrice ?? 0) > 0;
    if (!paid) {
      return priceVisibility === 'Hide' ? 'hidden' : 'free';
    }
    return priceVisibility === 'ShowFrom' ? 'from' : 'amount';
  }
}
